<template>
    <div class="d-flex align-items-center justify-content-between">
        <div>
            {{ attachment.AttachmentDefinitionName }}
            <pc-sensitive-icon
                v-if="attachment.AttachmentDefinitionIsSensitive"
                attachment />
        </div>
        <pc-button-row v-if="!wideView">
            <template v-slot:right>
                <pc-button
                    v-if="isAdminPage && showViewDownload"
                    class="btn-sm attachment-action-button"
                    data-test-role="action-link-view"
                    v-on:click="$emit('view-attachment')">
                    {{ viewButtonLabel }}
                </pc-button>
                <!-- Note: On landing page, "View" button downloads attachment -->
                <pc-button
                    v-if="showViewDownload"
                    class="btn-sm attachment-action-button"
                    data-test-role="action-link-download"
                    v-on:click="$emit('download-attachment')">
                    {{ downloadButtonLabel }}
                </pc-button>
            </template>
        </pc-button-row>
    </div>
</template>

<script>
    import { KEYS, NAMESPACE } from "./i18n/attachmentsUtil.i18n";
    import { mapI18n } from "Util/i18n";

    export default {
        props: {
            attachment: { type: Object, required: true },
            isAdminPage: { type: Boolean, required: true },
            wideView: { type: Boolean, required: true }
        },
        emits: ["view-attachment", "download-attachment"],
        data() {
            return {};
        },
        computed: {
            ...mapI18n(KEYS, NAMESPACE),
            showViewDownload() {
                if (!this.attachment.AttachmentDefinitionIsSensitive) {
                    return true;
                }
                return this.$app.loggedInUserHasViewSensitiveDataPrivilege;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .attachment-action-button {
        min-width: 5rem !important;
    }
</style>
